let controllers = [];
let items = [];

const updateSelectedController = selectedValue => {
  const previouslySelectedController = document.querySelector(
    '[data-list-item-toggle-controller-selected]',
  );
  delete previouslySelectedController.dataset.listItemToggleControllerSelected;

  const selectedValueSelector = selectedValue
    ? `[data-list-item-toggle-controller="${selectedValue}"]`
    : '[data-list-item-toggle-controller=""]';
  var selectedController = document.querySelector(selectedValueSelector);
  selectedController.dataset.listItemToggleControllerSelected = '';
};

const showAll = () => {
  items.forEach(item => {
    item.classList.remove('d-none');
  });
};

const applyToggle = value => {
  items.forEach(item => {
    const itemValue = item.dataset.listItemToggleItem;
    var itemValues = itemValue.split(', ');
    if (itemValues.includes(value)) {
      item.classList.remove('d-none');
    } else {
      item.classList.add('d-none');
    }
  });
};

const controllerClick = e => {
  const selectedValue = e.currentTarget.dataset.listItemToggleController;

  if (!selectedValue) {
    showAll();
  } else {
    applyToggle(selectedValue);
  }

  updateSelectedController(selectedValue);
};

const selectChange = e => {
  const filterDropDown = document.querySelector('.c-filter__dropdown-btn');
  const selectedValue = e.currentTarget.getAttribute(
    'data-list-item-toggle-select-item',
  );
  if (!selectedValue && filterDropDown) {
    showAll();
    filterDropDown.textContent = filterDropDown.getAttribute(
      'data-default-label',
    );
  } else {
    applyToggle(selectedValue);
    filterDropDown.textContent = e.currentTarget.textContent;
  }
};

export const initListItemToggle = () => {
  const select = document.querySelector('[data-list-item-toggle-select]');
  controllers = document.querySelectorAll('[data-list-item-toggle-controller]');
  items = document.querySelectorAll('[data-list-item-toggle-item]');
  if (!select || !controllers.length || !items.length) {
    return;
  }

  const selectItems = select.querySelectorAll(
    '[data-list-item-toggle-select-item]',
  );
  if (selectItems) {
    selectItems.forEach(el => el.addEventListener('click', selectChange));
  }
  controllers.forEach(el => {
    el.addEventListener('click', controllerClick);
  });
};
